import { createGlobalStyle } from 'styled-components';

import { colorsSpec, fontSizes } from './defaultTheme';

export default createGlobalStyle`
* {
    
    box-sizing: border-box;
    padding: 0;
    margin: 0;

    /* scrollbar-width: thin; For Firefox */
    scrollbar-color: ${({ theme }) =>
			theme?.colors[colorsSpec.white]}; /* For Firefox */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
      background: radial-gradient(
        50% 50% at 50% 50%,
        rgba(209, 225, 246, 0) 0%,
        rgba(209, 225, 246, 0.2) 100%
      );
      border-radius: 7px;
    }
    ::-webkit-scrollbar {
      width: 8px;
      background-color: #f5f5f5;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #bababa;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #9b9a9a;
      cursor: pointer;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  h1 {
    text-align: center;
    font-size: ${fontSizes.heading1};
  }

  h2 {
    font-size: ${fontSizes.heading2};
  }

  h3 {
    font-size: ${fontSizes.heading3};
  }

  h4 {
    font-size: ${fontSizes.heading4};
  }

  h5 {
    font-size: ${fontSizes.heading5};
  }`;
